export default {"src":"/_next/static/media/no-prepayment.043f04df.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};